<template>
  <div
    v-observe-visibility="{
      intersection: {
        threshold: 0.75,
      },
      callback: visibilityChanged,
      throttle: 750,
    }"
    class="w-full overflow-hidden" 
    :class="classes"
    style="background-size:cover; min-height:120px"
    :style="{ backgroundImage: visibleSource}"
  />
</template>

<script>
import { ObserveVisibility } from "vue-observe-visibility";
export default {
  directives: {
    ObserveVisibility
  },
  props: {
    src: {
      type: [String, Boolean],
      default: '',
    },
    classes: {
      type: Array,
      default: () => []
    },
    metric: {
      type: String,
      default: '',
    }
  },
  data:() => ({
    isVisible: false,
    currentVisibilityState: false,
    hasSentTracking: false,
    visibleSource: 'url(https://embed.flyo.cloud/gradient.png)'
  }),
  methods: {
    visibilityChanged (isVisible) {
      this.currentVisibilityState = isVisible
      if (isVisible) {
        this.isVisible = isVisible
        if (this.src) {
          this.visibleSource = `url(${this.src})`
        }
        setTimeout(() => {
          if (!this.hasSentTracking && this.currentVisibilityState) {
            fetch(this.metric)
            this.hasSentTracking = true
          }
        }, 4000)
      }
    }
  }
}
</script>